import { useSelector } from 'react-redux';

import { SubscriptionType } from '../constants';
import { selectGeneralSettings } from '../services/selectors';

export const useIsFreeTier = () => {
    const { subscription } = useSelector(selectGeneralSettings);

    return subscription === SubscriptionType.free;
};
